import { Injectable, NgZone } from '@angular/core';
import { UserService } from '@shared/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppURLType } from '@shared/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class MicrosoftService {
	constructor(
		private userService: UserService,
		public snackBar: MatSnackBar,
		private router: Router,
		private location: Location,
		private http: HttpClient
	) {}

	getMicrosoftPermisson() {
		return this.http.get('/api/microsoft-apis/login');
	}
}
